export default __webpack_public_path__ + "static/LastSecImage-ac9d5e8109a05f58779363e177fe8faf.webp";